import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { COLORS } from '../../theme';

export const CATEGORY_VISUALS = Object.freeze({
  pedido: { label: 'Pedido', Icon: ShoppingBagOutlinedIcon, color: COLORS.orange },
  pagamento: { label: 'Pagamento', Icon: PaidOutlinedIcon, color: COLORS.orangeVivid },
  arquivo: { label: 'Arquivo', Icon: FolderOutlinedIcon, color: COLORS.brandGray },
  selecao: { label: 'Seleção', Icon: PhotoLibraryOutlinedIcon, color: COLORS.orangeDeep },
  sistema: { label: 'Sistema', Icon: SettingsSuggestOutlinedIcon, color: COLORS.gray700 },
  conta: { label: 'Conta', Icon: PersonOutlineOutlinedIcon, color: COLORS.brandDark },
  outro: { label: 'Notificação', Icon: NotificationsNoneOutlinedIcon, color: COLORS.gray700 },
});

/** Tipo de destinatário exibido no histórico de envios. */
export const RECIPIENT_VISUALS = Object.freeze({
  cliente: { label: 'Cliente', Icon: PersonOutlineRoundedIcon, color: COLORS.brandGray },
  admin: { label: 'Admin', Icon: AdminPanelSettingsOutlinedIcon, color: COLORS.orange },
});

/** Abas do filtro por destinatário no histórico (vazio = todos). */
export const DESTINATARIO_FILTROS = Object.freeze([
  { valor: '', rotulo: 'Todos' },
  { valor: 'cliente', rotulo: 'Clientes' },
  { valor: 'admin', rotulo: 'Admins' },
]);

export const PRIORITY_COLORS = Object.freeze({
  baixa: 'text.disabled',
  normal: 'text.secondary',
  alta: 'warning.main',
  critica: 'error.main',
});

export const getCategoryVisual = (categoria) =>
  CATEGORY_VISUALS[categoria] || CATEGORY_VISUALS.outro;

export const getRecipientVisual = (tipo) => RECIPIENT_VISUALS[tipo] || RECIPIENT_VISUALS.cliente;

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Tempo relativo curto em pt-BR. Datas antigas caem para dd/mm/aaaa.
 * @param {string|Date} value
 * @param {number} [now]
 */
export const formatRelativeTime = (value, now = Date.now()) => {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const diff = now - date.getTime();

  if (diff < MINUTE) return 'agora';
  if (diff < HOUR) return `há ${Math.floor(diff / MINUTE)} min`;
  if (diff < DAY) return `há ${Math.floor(diff / HOUR)} h`;
  if (diff < 7 * DAY) return `há ${Math.floor(diff / DAY)} d`;

  return date.toLocaleDateString('pt-BR');
};

/**
 * Data/hora absolutas — usadas no histórico de envios, onde a ordem cronológica
 * importa mais do que a distância até agora.
 * @param {string|Date} value
 */
export const formatDateTime = (value) => {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
};
